import React  from 'react';
import { InputLabel } from '@mui/material';

const InputLabelCustom = (props) => {
    const { htmlFor, text } = props;
    return (
        <InputLabel {...props} shrink htmlFor={htmlFor}>
            {text}
        </InputLabel>
    )
}

export default InputLabelCustom;